import React, { Component } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import { configuration } from "../../appConfig";
import Axios from "axios";
import { connect } from "react-redux";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CartecPriceTable extends Component {
  count = [];
  state = {
    words: {},
    lang: "en",
    swissTableCH: [],
    data: [],
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  componentDidMount() {
    this.getData();
    this.getJsonApi();
    this.getLang();
  }
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  getJsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({ data: r.data.Dents });
      }
    });
  };
  getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const res = await Axios.get(
      configuration.getResultCH + "?vin=" + vin + "&partnerId=" + partnerId
    );
    if (res.data && res.data.json) {
      let { json } = res.data;
      const data = json.split("\n").splice(3);
      data.pop();
      const ltgtdataCH =
        data &&
        data.map((row) => {
          const val = row.split(/\s+/);
          let ltcount = val[2];
          let gtcount = val[3];
          return {
            part: val[1],
            count: parseInt(val[2]) + parseInt(val[3]),
            lt25: val[2],
            gt25: val[3],
            ltunit: calculatePrice(24, ltcount | 0),
            gtunit: calculatePrice(26, gtcount | 0),
          };
        });
      this.setState({ swissTableCH: ltgtdataCH });
    }
    // debugger;
  };
  partName = (pname) => {
    let parts = {
      Hood: "Motorhaube",
      LeftFrontFender: "Kotflugel V.L.",
      RightFrontFender: "Kotflugel V.R.",
      LeftFrontDoor: "Ture V.L.",
      LeftBackDoor: "Ture H.L.",
      RightFrontDoor: "Ture V.R",
      RightBackDoor: "Ture H.R",
      LeftBackFender: "Seitenwand H.L.",
      RightBackFender: "Seitenwand H.R.",
      Trunk: "Kofferdeckel",
      LeftRoofFrame: "Dachrand L.",
      RightRoofFrame: "Dachrand R.",
      Roof: "Schiebedach",
      TrunkCover: "TrunkCover",
    };
    return parts[pname];
  };
  render() {
    const { data } = this.state;
    return (
      <>
        <div className="container mt-50 damage-summary-section p-0 dns-pricetable cartech-report">
          <div className="row p-0">
            <div className="col-12 damage-summary-heading p-0">
              <h3>
                Reparatur Kostenberechnung <span> Hagelschäden</span>{" "}
              </h3>
            </div>
          </div>
          <div className="row p-0 damage-summary-table">
            <div className="col-lg-12 p-0">
              <table width="100%" className=" table table-responsive  w-100">
                <tbody width="100%">
                  <tr width="100%">
                    <th width="25%">Teile</th>
                    <th width="15%" colSpan="2">
                      {" "}
                      Durchmesser{" "}
                    </th>
                    <th width="10%"></th>
                    <th width="20%" colSpan="2">
                      Zuschlage{" "}
                    </th>
                    <th width="25%" colSpan="2">
                      Arbeiten
                    </th>
                  </tr>
                  <tr>
                    <td></td>
                    <td style={{ textAlign: "center" }}>{"25mm"}</td>
                    <td style={{ textAlign: "center" }}>{"25mm+"}</td>
                    <td style={{ textAlign: "center" }}>{"Kleben"}</td>
                    <td style={{ textAlign: "center" }}>{"Alu"}</td>
                    <td style={{ textAlign: "center" }}>{"Grossflachig"}</td>
                    <td style={{ textAlign: "center" }}>{"Drucken in A  "}</td>
                    <td style={{ textAlign: "center" }}>{"Montage in AW"}</td>
                  </tr>
                  {data &&
                    data.map((row, index) => (
                      <tr className="border" key={index}>
                        <td>{this.lang(row.Part)}</td>
                        <td className="" style={{ textAlign: "center" }}>
                          {row.A}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                          {row.B}
                        </td>
                        <td className="" style={{ textAlign: "center" }}></td>
                        <td className="" style={{ textAlign: "center" }}>
                          {/* {row.ltunit} */}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                          {/* {row.gtunit} */}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                          {/* {row.count} */}
                        </td>
                        <td className="" style={{ textAlign: "center" }}>
                          {/* {row.AW} */}
                        </td>
                      </tr>
                    ))}
                  <tr>
                    <td>
                      {" "}
                      <b>Gesamt Dents</b>{" "}
                    </td>
                    <td
                      className=""
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {data &&
                        data.reduce((acc, num) => parseInt(acc) + num.A, 0)}
                    </td>
                    <td style={{ textAlign: "center", fontWeight: "bold" }}>
                      {data &&
                        data.reduce((acc, num) => parseInt(acc) + num.B, 0)}
                    </td>
                    <td colSpan></td>
                    <td colSpan></td>
                    <td style={{ textAlign: "center" }}></td>
                    <td></td>
                    <td style={{ textAlign: "center" }}>
                      {/* {this.state.swissTableCH.length &&
                        this.state.swissTableCH.reduce(
                        (acc, num) =>
                        parseInt(acc) + num.ltunit + num.gtunit,
                        0
                        )} */}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }}>WindlaufVo</td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}> </td>
                  </tr>
                  <tr
                    height={23}
                    style={{ msoHeightSource: "userset", height: "17.85pt" }}
                  >
                    <td
                      colSpan={4}
                      height={23}
                      className="xl65"
                      style={{ height: "17.85pt" }}
                    >
                      Verrechnungslohn Spengler
                    </td>
                    <td
                      colSpan={2}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                    <td
                      colSpan={6}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                  </tr>
                  <tr
                    height={23}
                    style={{ msoHeightSource: "userset", height: "17.45pt" }}
                  >
                    <td
                      colSpan={4}
                      height={23}
                      className="xl65"
                      style={{ height: "17.45pt" }}
                    >
                      Rabatt %
                    </td>
                    <td
                      colSpan={2}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                    <td
                      colSpan={6}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                  </tr>
                  <tr
                    height={23}
                    style={{ msoHeightSource: "userset", height: "17.45pt" }}
                  >
                    <td
                      colSpan={4}
                      height={23}
                      className="xl65"
                      style={{ height: "17.45pt" }}
                    >
                      Klein und Verbrauchsmaterial 5%
                    </td>
                    <td
                      colSpan={2}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                    <td
                      colSpan={6}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                  </tr>
                  <tr
                    height={23}
                    style={{ msoHeightSource: "userset", height: "17.45pt" }}
                  >
                    <td
                      colSpan={4}
                      height={23}
                      className="xl65"
                      style={{ height: "17.45pt" }}
                    >
                      Total in Fr.
                    </td>
                    <td
                      colSpan={2}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                    <td
                      colSpan={6}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                  </tr>
                  <tr
                    height={23}
                    style={{ msoHeightSource: "userset", height: "17.45pt" }}
                  >
                    <td
                      colSpan={4}
                      height={23}
                      className="xl65"
                      style={{ height: "17.45pt" }}
                    >
                      MwSt.
                    </td>
                    <td
                      colSpan={2}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                    <td
                      colSpan={6}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                  </tr>
                  <tr
                    height={23}
                    style={{ msoHeightSource: "userset", height: "17.45pt" }}
                  >
                    <td
                      colSpan={4}
                      height={23}
                      className="xl65"
                      style={{ height: "17.45pt" }}
                    >
                      Total inkl. MwS
                    </td>
                    <td
                      colSpan={2}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                    <td
                      colSpan={6}
                      className="xl67"
                      style={{ borderLeft: "none" }}
                    ></td>
                  </tr>
                  <tr style={{ msoHeightSource: "userset", height: "80pt" }}>
                    <td colSpan={12}></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CartecPriceTable);
